<template>
  <!-- <div class="container mt-4 mb-4" v-if="isloading">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <p class="spinner-border"></p>
          </div>
        </div>
      </div>
    </div>
  </div> -->
  <base-spinner :open="isloading"></base-spinner>

  <div class="container mt-4 mb-4" v-if="isloading">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <base-message
            v-if="!isloading"
            :servermessages="servermessages"
            ></base-message>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  <div class="site__body" v-if="!isloading">
    <!-- <div class="block-header block-header--has-breadcrumb block-header--has-title"> -->
      <div class="container">
        <div class="flex-container--breadcrumbs-selected-vehicle">
          <!-- <div class="flexbox-page-info-container"> -->
            <div class="flexbox-container--breadcrumbs" style="margin-bottom: 0px">
              <nav class="breadcrumb block-header__breadcrumb" aria-label="breadcrumb">
                <ol class="breadcrumb__list breadcrumb__list-product-detail">
                  <li class="breadcrumb__spaceship-safe-area" role="presentation"></li>
                  <li class="breadcrumb__item breadcrumb__item--parent breadcrumb__item--first" >
                    <router-link to="/home" class="breadcrumb__item-link">Home</router-link>
                  </li>
                  <li class="breadcrumb__item breadcrumb__item--parent">
                    <router-link to="/search-results" class="breadcrumb__item-link">Search Results</router-link>
                  </li>
                  <li class="breadcrumb__item breadcrumb__item--current breadcrumb__item--last" aria-current="page" >
                    <span class="breadcrumb__item-link">{{ whi_product.sku }}</span>
                  </li>
                </ol>
              </nav>
            </div>
            <!-- <selected-vehicle></selected-vehicle> -->
            <base-selected-vehicle></base-selected-vehicle>
            <div class="block-space block-space--layout--divider-nl"></div>
          <!-- </div> -->
        </div>
      </div>
    <!-- </div> -->


    <div class="block-split block-split--has-sidebar" v-if="!isloading">
      <div class="container">
        <div class="block-split__row row no-gutters">
            <!-- <div class="block-split__item block-split__item-sidebar col-auto">
                <product-categories></product-categories> 
                <latest-products></latest-products> 
            </div> -->

            <div class="block-split__item block-split__item-content col-auto" id="whiIframe" >
                <div class="product product--layout--sidebar">
                    <div class="product__body" >
                        <!-- <div class="product__card product__card--one"></div> -->
                        <!-- <div class="product__card product__card--two"></div> -->

                        <iframe :src="whi_product.smartpage_url"></iframe>

                        <div class="product__info">
                            <whi-right-col></whi-right-col>

                            <div></div>
                        </div>
                    </div>
                </div>
                <div class="block-space block-space--layout--divider-thin"></div>
            </div>
        </div>
      </div>
    </div>

    <div class="block-space block-space--layout--before-footer"></div>
  </div>
</template>

<script>
// import LatestProducts from "../productdetail/LatestProducts";
import WhiRightCol from "./WhiRightCol";
import { mapGetters } from 'vuex';

export default {
    name: "WHIProductDetail",
    components: {
        // LatestProducts,
        WhiRightCol
    },
    data() {
        return {
            
        }
    },
    computed: {
        ...mapGetters('product', [
            'whi_smart_url',
            'whi_product',
        ]),

    },
    methods: {
        getProductDetails() {
            
        }
    },
    watch: {
    },
    created() {
        this.$ga.page({
            page: this.$route.fullPath,
            title: this.$route.name,
        });
        console.log(this.whi_product);
    },

};
</script>

<style scoped>
    #whiIframe {
        min-height: 800px;
        width: 100%;
    }

    iframe {
        min-height: 800px;
    }
</style>
